import { render, staticRenderFns } from "./Denounce-list.vue?vue&type=template&id=555c466a"
import script from "./Denounce-list.vue?vue&type=script&lang=js"
export * from "./Denounce-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports